import { usePmsReachOrEmpty } from './PmsProvider.js';

// A row's établissement, on a list that shows every établissement in reach
// (U3, PMS-UNIFIED-DESK-BRIEF §3 M11′ item 1: « each row marked with its
// établissement where it could be mistaken »). Nothing at all with one
// établissement in reach: the single-building screen stays exactly as it was.

export function EtablissementTag({ code }: { code: string }) {
  const reach = usePmsReachOrEmpty();
  if (reach.length < 2) return null;
  const label = reach.find((b) => b.property.code === code)?.property.labelFr ?? code;
  return (
    <span className="pms-etab-tag" data-testid="etab-tag">
      {label}
    </span>
  );
}
